// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 1V2H15V1H17V3.16228L16 6.16228V15H17V18H19V23H5V18H7V15H8V6.16228L7 3.16228V1H9ZM14.2792 5L14.6126 4H9.38743L9.72076 5H14.2792ZM9 17V18H15V17H9ZM17 20H7V21H17V20Z"}}]};

const MonumentFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'monument-filled',
    ref,
    icon: element,
  },
));

MonumentFilledIcon.displayName = 'MonumentFilledIcon';

export default MonumentFilledIcon;
